import React from "react";
import PropTypes from "prop-types";
import { Badge, Col, Row } from "reactstrap";
import ImgContainer from "components/common/img";
import { useNavigate } from "react-router";
import styled from "styled-components";
import useAuth from "hooks/useAuth";
import { ACCOUNT_HOUSE_SPEAKER } from "utility/constants";

const ProjectContainer = styled.div`
  width: 100%;
`;

const BadgeContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-end;
  height: 0px;
`;

const AgencyLabelContainer = styled(Col)`
  padding: 0;

  @media (max-width: 575px) {
    display: none;
  }
`;

const PendingBadge = styled(Badge)`
  position: relative;
  top: -10px;
  right: -10px;
  background-color: #00326e !important;
  box-shadow: 0px 5px 7px rgba(0, 0, 0, 0.19);
  margin-left: 0.25rem;
`;

const RequestedBadge = styled(PendingBadge)`
  background-color: #f3c61c !important;
  color: black;

  &.is-hidden {
    background-color: transparent !important;
    top: 0px;
    right: 0px;
    box-shadow: none;
    color: transparent;
  }
`;

const ProgramContainer = styled(Row)`
  background: #ffffff;
  border-radius: 11px;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0;
  margin: 0;
  width: 100%;
  min-height: 125px;

  @media (max-width: 768.98px) {
    img {
      height: 70px;
    }
  }

  &:hover {
    h6 {
      color: ${({ theme }) => theme.colors.systemBlue};
    }
  }
`;

const ProgramLabel = styled.h6`
  margin-bottom: 0;
`;

const AgencyContainer = (props) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const role = user?.type;

  const handleOnClick = () => {
    navigate(props?.link);
  };

  if (!user) {
    return null;
  }

  return (
    <ProjectContainer>
      {role !== ACCOUNT_HOUSE_SPEAKER ? (
        <BadgeContainer>
          {props?.requestedCount !== 0 && (
            <RequestedBadge
              className={`${props?.requestedCount === 0 ? "is-hidden" : ""}`}
              pill
            >
              <div>{props?.requestedCount}</div>
            </RequestedBadge>
          )}

          {props?.pendingCount !== 0 && (
            <PendingBadge pill>
              <div>{props?.pendingCount}</div>
            </PendingBadge>
          )}
        </BadgeContainer>
      ) : null}
      <ProgramContainer onClick={handleOnClick}>
        <Col xs="auto">
          <ImgContainer
            height="90px"
            src={props?.photo}
          />
        </Col>
        <AgencyLabelContainer>
          <ProgramLabel>{`${props?.label} (${props?.acronym})`}</ProgramLabel>
        </AgencyLabelContainer>
      </ProgramContainer>
    </ProjectContainer>
  );
};

AgencyContainer.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
};

export default AgencyContainer;
